import React, { useRef, useEffect } from 'react';
import Navbar from '../../components/common/Header/Navbar';
import bannerimg from '../../assets/Recharge_api_images/bbps_banner.png';
import missionvissonimg from '../../assets/Recharge_api_images/bbps_api_img.jpg';
import "../../styles/recharge_api.css";
import increasedRevenueIcon from '../../assets/Recharge_api_images/increase1.png';
import scalabilityIcon from '../../assets/Recharge_api_images/relationships2.png';
import customerRetentionIcon from '../../assets/Recharge_api_images/retension.png';
import fintechIcon from '../../assets/Recharge_api_images/fintech.png';
import retailIcon from '../../assets/Recharge_api_images/retail.png';
import ecommerceIcon from '../../assets/Recharge_api_images/Ecommerce.png';
import benefitBanner from '../../assets/Recharge_api_images/benefit_banner.png';

import securityMeasuresImage from '../../assets/Recharge_api_images/security1.png';
import securitysecurityMeasuresImage from '../../assets/Recharge_api_images/security2.png';

import integrationProcessImage from '../../assets/Recharge_api_images/integration_background.png';




const BbpsApis = () => {


  const featuresCarouselRef = useRef(null);
  const featuresIndicatorsRef = useRef(null);

  // Features Carousel - React Hook Version
  useEffect(() => {
    const carousel = featuresCarouselRef.current;
    if (!carousel || window.innerWidth > 768) return;

    const indicators = featuresIndicatorsRef.current?.querySelectorAll('.indicator');
    const slides = carousel.querySelectorAll('.feature-slide');
    let currentSlide = 0;
    const slideCount = slides.length;

    const updateIndicators = () => {
      indicators?.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === currentSlide);
      });
    };

    const goToSlide = (slideIndex) => {
      currentSlide = slideIndex;
      const slideWidth = slides[0].offsetWidth;
      carousel.scrollTo({ left: slideIndex * slideWidth, behavior: 'smooth' });
      updateIndicators();
    };

    // Click indicators
    indicators?.forEach((indicator, index) => {
      indicator.addEventListener('click', () => goToSlide(index));
    });

    // Auto-update indicators on scroll
    const handleScroll = () => {
      const slideWidth = slides[0].offsetWidth;
      const scrollLeft = carousel.scrollLeft;
      const newSlide = Math.round(scrollLeft / slideWidth);
      if (newSlide !== currentSlide) {
        currentSlide = newSlide;
        updateIndicators();
      }
    };

    carousel.addEventListener('scroll', handleScroll);

    // Initial update
    updateIndicators();

    // Cleanup
    return () => {
      indicators?.forEach((indicator, index) => {
        indicator.removeEventListener('click', () => goToSlide(index));
      });
      carousel.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const FeatureBox = ({ title, description, isPrimary = false, className = '' }) => (
    <div className={`feature-box ${isPrimary ? 'feature-box-primary' : 'feature-box-secondary'} ${className}`}>
      <h4 className="feature-title font-lato text-[20px] font-bold">{title}</h4>
      <p className="feature-description text-ellipsis  font-lato text-[17px] font-normal leading-[26px]">{description}</p>
    </div>
  );

  // ✅ you used values in CoreValues & HowItWorks but didn’t define it
  const values = [
    { title: "Integrity", desc: "We believe in transparency and trust." },
    { title: "Innovation", desc: "We build solutions for tomorrow." },
  ];

  // Features Carousel Functionality
  class FeaturesCarousel {
    constructor() {
      this.track = document.getElementById('featuresCarouselTrack');
      this.indicators = document.querySelectorAll('.carousel-indicators .indicator');
      this.prevArrow = document.querySelector('.carousel-arrow-prev');
      this.nextArrow = document.querySelector('.carousel-arrow-next');
      this.slides = document.querySelectorAll('.carousel-slide');
      this.currentSlide = 0;
      this.slideCount = this.slides.length;

      this.init();
    }

    init() {
      // Add event listeners
      this.indicators.forEach(indicator => {
        indicator.addEventListener('click', (e) => {
          const slideIndex = parseInt(e.target.dataset.slide);
          this.goToSlide(slideIndex);
        });
      });

      this.prevArrow.addEventListener('click', () => {
        this.prevSlide();
      });

      this.nextArrow.addEventListener('click', () => {
        this.nextSlide();
      });

      // Touch/swipe support for mobile
      this.addTouchSupport();

      // Auto-play (optional - remove if not needed)
      // this.startAutoPlay();
    }

    goToSlide(slideIndex) {
      this.currentSlide = slideIndex;
      this.updateCarousel();
    }

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slideCount;
      this.updateCarousel();
    }

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slideCount) % this.slideCount;
      this.updateCarousel();
    }

    updateCarousel() {
      // Move track
      const slideWidth = this.slides[0].offsetWidth;
      this.track.style.transform = `translateX(-${this.currentSlide * slideWidth}px)`;

      // Update indicators
      this.indicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === this.currentSlide);
      });

      // Update arrow states
      this.prevArrow.disabled = this.currentSlide === 0;
      this.nextArrow.disabled = this.currentSlide === this.slideCount - 1;
    }

    addTouchSupport() {
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.track.style.transition = 'none';
      });

      this.track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diff = startX - currentX;
        this.track.style.transform = `translateX(calc(-${this.currentSlide * 100}% - ${diff}px))`;
      });

      this.track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        this.track.style.transition = 'transform 0.3s ease-in-out';

        const diff = startX - currentX;
        const threshold = 50; // Minimum swipe distance

        if (diff > threshold && this.currentSlide < this.slideCount - 1) {
          this.nextSlide();
        } else if (diff < -threshold && this.currentSlide > 0) {
          this.prevSlide();
        } else {
          this.updateCarousel(); // Return to current slide
        }
      });
    }

    startAutoPlay() {
      // Optional auto-play functionality
      setInterval(() => {
        this.nextSlide();
      }, 5000); // Change slide every 5 seconds
    }
  }




  const BenefitCard = ({ icon, title, description, isBlue = false }) => (
    <div
      className={`benefit-card  group p-6 rounded-xl shadow-lg transition-colors duration-300 cursor-pointer`}
    >
      <div className="card-icon-container mb-4">
        {icon ? (
          <img src={icon} alt={title} className="card-icon w-12 h-12" />
        ) : (
          <div className="card-icon-placeholder w-12 h-12"></div>
        )}
      </div>
      <h3 className="card-title text-gray-900 text-xl font-semibold mb-2 transition-colors duration-300">
        {title}
      </h3>
      <p
        className="card-description text-[#6E6E6E] transition-colors duration-300 font-lato text-[17px] font-normal leading-[26px]"
      >
        {description}
      </p>
    </div>
  );



  const renderImageCard = (imageSrc, altText, title, description, linkText) => (
    <div className="image-card-container">
      {/* The main background image holder (dark curved shape) */}
      <div className="image-card-background">
        {imageSrc ? (
          <img src={imageSrc} alt={altText} className="content-image" />
        ) : (
          <div className="image-placeholder"></div>
        )}
      </div>

      {/* The nested white card with text overlay */}
      <div className="image-text-card">
        <h3>{title}</h3>
        <p>{description}</p>
        <a href="#" className="see-more-link">{linkText} →</a>
      </div>
    </div>
  );



  return (
    <>
      {/* Navbar */}
      {/* <Navbar /> */}

      {/* Banner Section */}

      <div className="relative w-full h-[300px] md:h-auto min-h-52">
        <img
          src={bannerimg}
          alt="About Banner"
          className="w-full h-full object-cover" // Added h-full and object-cover to make sure the image fills the container height
        />
        <div className="banner-content absolute inset-0  flex flex-col items-center justify-center px-6 py-12 md:pb-1 xs:pb-1">
          <h1
            className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal" // Made font size responsive
          >
            BBPS API
          </h1>

          <p
            className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2" // Made font size responsive and added margin top
          >
            Simplified Bill Payments for Utilities, Loans & Insurance


          </p>
        </div>
      </div>



      {/* Content Section */}
      <section className="recharge-api-section">
        <div className="content-container">
          {/* --- LEFT COLUMN: TEXT & FEATURES --- */}
          <div className="text-and-features-column">
            <p className="section-tag">OUR CORE API SERVICES</p>
            <h1 className="main-title">
              Simplified Bill Payments for <br></br> Utilities, Loans & Insurance
            </h1>
            <p className="main-description font-lato text-[17px] font-normal leading-[26px]">
              BBPS API enables seamless bill payments for utilities, loans, and insurance, offering a secure and efficient payment experience for businesses and customers.
            </p>


            {/* old  */}
            {/* --- FEATURES GRID --- */}
            <div className="features-grid">
              <FeatureBox
                title="Comprehensive Utility Coverage"
                description="Supports electricity, water, gas, broadband, and more for seamless bill payments."
                className="feature-box-2-of-5"
              />
              <FeatureBox
                title="Real-Time Payment Updates"
                description="Get instant transaction confirmations for seamless and secure payments."
                className="feature-box-2-of-5"
              />

              <FeatureBox
                title="Multiple Payment Methods"
                description="Supports UPI, Cards, and Net Banking for seamless and flexible transactions."
                className="feature-box-3-of-5"
              />
              <FeatureBox
                title="Advanced Security Encryption"
                description="Ensures safe and secure transactions with high-level encryption."
                className="feature-box-3-of-5"
              />
            </div>
            {/* --- END FEATURES GRID --- */}


            {/* new */}

            {/* --- FEATURES GRID --- */}
            {/* <div className="carousel-container">
  <div className="features-grid" ref={featuresCarouselRef}>
    <div className="feature-slide">
      <FeatureBox
        title="Comprehensive Utility Coverage"
        description="Supports electricity, water, gas, broadband, and more for seamless bill payments."
        className="feature-box-2-of-5 feature-box feature-box-secondary"
      />
    </div>
    <div className="feature-slide">
      <FeatureBox
        title="Real-Time Payment Updates"
        description="Get instant transaction confirmations for seamless and secure payments."
        className="feature-box-2-of-5 feature-box feature-box-secondary"
      />
    </div>
    <div className="feature-slide">
      <FeatureBox
        title="Multiple Payment Methods"
        description="Supports UPI, Cards, and Net Banking for seamless and flexible transactions."
        className="feature-box-3-of-5 feature-box feature-box-secondary"
      />
    </div>
    <div className="feature-slide">
      <FeatureBox
        title="Advanced Security Encryption"
        description="Ensures safe and secure transactions with high-level encryption."
        className="feature-box-3-of-5 feature-box feature-box-secondary"
      />
    </div>
    
    <div className="feature-slide ">
      <FeatureBox
        title="Seamless App Integration"
        description={
          <>
            Effortlessly integrate with both mobile and <br /> web applications for a smooth user experience.
          </>
        }
        className="seamless-card-int1 feature-box-3-of-5 feature-box feature-box-secondary"
      />
    </div>
  </div>
  <div className="carousel-indicators" ref={featuresIndicatorsRef}>
    <span className="indicator" data-slide="0"></span>
    <span className="indicator" data-slide="1"></span>
    <span className="indicator" data-slide="2"></span>
    <span className="indicator" data-slide="3"></span>
    <span className="indicator" data-slide="4"></span>
  </div>
</div> */}
            {/* --- END FEATURES GRID --- */}







          </div>

          {/* --- RIGHT COLUMN: IMAGE + LAST FEATURE BOX --- */}
          <div className="illustration-column flex flex-col items-start ml-24">
            <img
              src={missionvissonimg}
              alt="Identity Verification Illustration"
              className="recharge-illustration bbps"
            />
            <FeatureBox
              title="Seamless App Integration"
              description={
                <>
                  Effortlessly integrate with both mobile and <br /> web applications for a smooth user experience.
                </>
              }
              className="seamless-card-int feature-box-3-of-5 "
            />
          </div>

        </div>
      </section>

      {/* Our Mission Section */}
      <div>
        <section className="benefits-section relative overflow-hidden">
          <div
            className="absolute top-0 left-0 w-full h-[400px]  z-0"
            style={{
              backgroundImage: `url(${benefitBanner})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          {/* 3. Apply the style object and add an overlay div */}
          <div className="benefits-header-content-bg">
            {/* 4. Overlay div for the dark blue tint effect from the original image */}
            <div className="benefits-header-overlay"></div>
          </div>

          <div className="benefits-header-content">
            <div className="header-text-container">
              <p className="header-tag">BENEFITS & USE CASES</p>
              <h2 className="header-title">Maximize Efficiency with Our APIs</h2>
            </div>
            <div className="header-description-container">
              <p className="header-description text-justify">
                Enhance your business with secure, fast, and scalable API solutions. Streamline transactions, optimize operations, and improve customer experience effortlessly.
              </p>
            </div>
          </div>

          <div className="benefits-cards-grid-container">
            <div className="benefits-cards-grid">
              {/* Top Row: Benefits */}
              <BenefitCard
                icon={increasedRevenueIcon}
                title="Revenue Growth"
                description="Boost your earnings by adding service fees on every successful transaction."
              />
              <BenefitCard
                icon={scalabilityIcon}
                title="Customer Engagement"
                description="Deliver essential and recurring services to keep customers connected and loyal."
              />
              <BenefitCard
                icon={customerRetentionIcon}
                title="Regulatory Compliance"
                description="Stay fully compliant with NPCI and industry security standards."
              />

              {/* Bottom Row: Use Cases */}
              <BenefitCard
                icon={fintechIcon}
                title="Banking & Fintech Apps"
                description="Enable seamless bill payments directly through wallets and fintech platforms."
              />
              <BenefitCard
                icon={retailIcon}
                title="Retail & E-commerce"
                description="Offer bill payments as a value-added feature to enhance customer experience. "
              />
              <BenefitCard
                icon={ecommerceIcon}
                title="Utility Companies"
                description="Simplify payments and operations through secure API integration."
              />
            </div>
          </div>
        </section>
      </div>

      {/* Core Values & How It Works */}

      <section className="relative py-16 px-4 md:px-8 lg:px-16 overflow-hidden" style={{
        backgroundImage: `url(${integrationProcessImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <div className=" max-h-3xl mx-auto">
          {/* --- Top Section Header and Title --- */}
          <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
          >
            Integration & Security
          </span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12 leading-tight">
            Seamless Integration With <br />
            Advanced Security
          </h1>

          {/* -------------------------------------- */}
          {/* --- 1. Integration Process Section --- */}
          {/* -------------------------------------- */}
          <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">

            <div className="relative w-full lg:w-1/2 min-h-[300px]">
              <div className="w-full h-full absolute top-0 left-0">
                <img
                  src={securityMeasuresImage}
                  alt="Integration Process"
                  className="w-[90%] h-full object-cover rounded-xl shadow-2xl"

                />
              </div>


              <div
                className="absolute top-1/4 right-0 bg-[#F9F9F9] rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]
             flex flex-col items-start p-6 flex-1">
                <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
                <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                  Seamlessly integrate our APIs with your platform using our well-documented,...
                </p>
                <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                  SEE MORE <span className="ml-2">→</span>
                </a>
              </div>
            </div>

            {/* Right Side: Checklist */}
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
              <ul className="space-y-6">
                {[
                  "API Registration – Get API keys and credentials. .",
                  "Sandbox Testing – Run transactions in a controlled environment.",
                  "Deployment – Enable live transactions with encryption.",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#00AFEF]  font-bold text-lg mr-3 mt-1">✓</span>
                    <p className="text-lg text-gray-700">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* ------------------------------------- */}
          {/* --- 2. Security Measures Section --- */}
          {/* ------------------------------------- */}

          <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
              <span
                className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]"
              >
                Integration & Security
              </span>
              {/* Removed <br></br> */}

              {/* Added mt-4 or mb-4 to the list for separation */}
              <ul className="space-y-6 mt-4">
                {[
                  "Secure Payment Gateway: Ensures safe data transmission. ",
                  "Fraud Prevention Mechanisms: Detects anomalies in payments. ",
                  "Audit Trails & Reporting: Maintain records for compliance and tracking. ",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#00AFEF] font-bold text-lg mr-3 mt-1">✓</span>
                    <p className="text-lg text-gray-700">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative w-full lg:w-1/2 min-h-[300px]">
              <div className="w-full h-full absolute top-0 left-0">
                <img
                  src={securitysecurityMeasuresImage}
                  alt="Integration Process"
                  className="w-[90%] h-full object-cover rounded-xl shadow-2xl"

                />
              </div>

              <div className="absolute top-1/4 right-0 bg-[#F9F9F9] p-6 rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]">
                <h3 className="text-xl font-bold text-gray-800 mb-2">Integration Process</h3>
                <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                  Seamlessly integrate our APIs with your platform using our well-documented,...
                </p>
                <a href="#" className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150">
                  SEE MORE <span className="ml-2">→</span>
                </a>
              </div>
            </div>


          </div>



        </div>
      </section>




    </>
  );
};

export default BbpsApis;
